// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React, { useEffect, useCallback } from "react";

import {
  PopupContainer,
  closeIcon,
  popupHeader,
  DeleteTextContainer
} from "./styles";
import Icon from "src/components/Icon";
import { getSelectedChecklist } from "src/reducers";
import * as colors from "src/styles/constants/colors";
import { iconSize } from "src/styles/constants/size";
import { HStack, Button, Flex, Box, Text } from "@chakra-ui/react";
import appLocation from "src/constants/location";

type Props = {
  isOpen: boolean,
  setConfirmation: Function,
  name: string,
  fileSource: string | null,
  handleRemove: Function,
  handleDelete: Function,
  filename: string,
  location?: string
};

const Modal = ({
  isOpen,
  name,
  fileSource,
  handleRemove,
  handleDelete,
  setConfirmation,
  filename,
  location
}: Props) => {
  const closeModal = useCallback(
    (event: any) => {
      if (event.key === "Escape") {
        setConfirmation(false);
      }
    },
    [setConfirmation]
  );

  useEffect(() => {
    document.addEventListener("keydown", closeModal, false);
    return () => {
      document.removeEventListener("keydown", closeModal, false);
    };
  }, []);

  const removeFile = () => {
    handleRemove(name);
    setConfirmation(false);
  };

  const deleteFile = () => {
    handleDelete(name);
    setConfirmation(false);
  };

  const fileName = filename.slice(0, -4);
  const extension = filename.slice(-3);

  return (
    isOpen && (
      <PopupContainer>
        <Flex {...popupHeader}>
          <Flex sx={DeleteTextContainer}>
            <Text
              as="span"
              sx={{
                display: "flex",
                textOverflow: "ellipsis"
              }}
            >
              {" "}
              {location === appLocation.filesModal ? (
                <>
                  {i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_DELET1)}
                  <Text
                    as="span"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "50%",
                      display: i18n.t(k.INLINE_BLOCK)
                    }}
                  >
                    {`${fileName}`}{" "}
                  </Text>
                  {`${i18n.t(k._9)}${extension}`}
                  {i18n.t(k._10)}
                </>
              ) : (
                <>{i18n.t(k.ARE_YOU_SURE_YOU_WANT_TO_REMOV1)}</>
              )}
            </Text>
          </Flex>
          <Box
            as="button"
            onClick={() => setConfirmation(false)}
            {...closeIcon}
          >
            <Icon icon="close" color={colors.primary} size={iconSize.space_m} />
          </Box>
        </Flex>
        <HStack
          mt={-4}
          sx={
            location === appLocation.filesModal && {
              flexDirection: "row-reverse",
              gap: "0.5rem"
            }
          }
        >
          {fileSource !== "microsoft365" && (
            <Button
              data-cy="deleteFile"
              colorScheme="red"
              onClick={deleteFile}
              size="xs"
            >
              {i18n.t(k.DELETE)}
            </Button>
          )}
          <Button
            data-cy="removeFileButton"
            onClick={removeFile}
            size="xs"
            colorScheme="red"
            variant="outline"
          >
            {i18n.t(k.REMOVE_FROM_CHECKLIST)}
          </Button>
        </HStack>
      </PopupContainer>
    )
  );
};

export default Modal;
